import React, { } from 'react'
import { Badge, Box, IconButton, List, ListItem, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import BackupOutlinedIcon from '@material-ui/icons/BackupOutlined';

const DefaultObservationList = ({ readonly, observations, onSelect, onDelete }) => {

  return (
    <>
      <Box>
        <List component="nav" aria-label="waarnemingen" style={{ marginBottom: '57px' }}>
          {observations && observations.length > 0 ?
            observations.filter(item => !item.delstaId).map((item, i) => (
              <ListItem button key={item.id} onClick={(e) => onSelect(item, i)} divider>
                <ListItemText primary={item.description || 'nieuwe waarneming'} />
                <ListItemSecondaryAction>
                  {item.offline &&
                    <IconButton aria-label="upload" disabled>
                      <BackupOutlinedIcon color={item.error ? 'error' : 'primary'} />
                    </IconButton>
                  }
                  {!readonly ?
                    <IconButton aria-label="delete" onClick={(e) => onDelete(item)} >
                      <DeleteIcon />
                    </IconButton>
                    : ''}
                  <Badge color="primary" badgeContent={item.abundance} max={99} onClick={(e) => onSelect(item)}></Badge>
                </ListItemSecondaryAction>
              </ListItem>
            ))
            : <p><i>Geen waarnemingen</i></p>}
        </List>
      </Box>
    </>
  )
}

export default DefaultObservationList